import { GetTopUpSubscriptionDto, TopUpSubscriptionDto } from "@libs/shares/dto/topUpSubscription.dto";
import { firstValueFrom } from "rxjs";
import { AuthHttpClient } from "../auth/auth-client.service";
import { environment } from "apps/portal-webapp/src/environments/environment";
import { Injectable, inject } from "@angular/core";
import { TopUpItem } from "@libs/shares/models/models";

@Injectable({
  providedIn: "root"
})
export class SubscriptionTopUpService {
  authHttpClient = inject(AuthHttpClient);

  async getPendingTopUp(subscriptionId: bigint) {
    return firstValueFrom(
      this.authHttpClient.get<GetTopUpSubscriptionDto | null>(
        `${environment.apiBaseUrl}/subscriptions/${subscriptionId}/top-up`
      )
    );
  }

  async createTopUpRequest(topUpDto: TopUpSubscriptionDto) {
    return firstValueFrom(
      this.authHttpClient.post<GetTopUpSubscriptionDto | null>(
        `${environment.apiBaseUrl}/subscriptions/${topUpDto.subscriptionId}/top-up`,
        topUpDto
      )
    );
  }

  async getTopUpById(subscriptionId: bigint, topUpId: bigint) {
    return firstValueFrom(
      this.authHttpClient.get<GetTopUpSubscriptionDto>(
        `${environment.apiBaseUrl}/subscriptions/${subscriptionId}/top-up/${topUpId}`
      )
    );
  }

  async deleteTopUp(subscriptionId: bigint, topUpId: bigint) {
    return firstValueFrom(
      this.authHttpClient.delete<void>(`${environment.apiBaseUrl}/subscriptions/${subscriptionId}/top-up/${topUpId}`)
    );
  }

  async updateTopUp(subscriptionId: bigint, topUpId: bigint, topUpItems: TopUpItem[]) {
    return firstValueFrom(
      this.authHttpClient.patch<GetTopUpSubscriptionDto>(
        `${environment.apiBaseUrl}/subscriptions/${subscriptionId}/top-up/${topUpId}`,
        {
          topUpItems
        }
      )
    );
  }
}
